module.exports = __webpack_public_path__ + "img/piaobai03.047716fb.png";